// Offset paging arithmetic, in one place.
//
// The BFF's `patients` query returns { total, limit, offset } and caps limit at
// 100. The screen thinks in 1-based pages (that is what the pager renders) and
// the wire thinks in offsets, so the conversion happens here rather than being
// re-derived at three call sites with three different off-by-ones.

export const DEFAULT_PAGE_SIZE = 25;

/** How many pages `total` rows make at `limit` per page. Never below 1. */
export function pageCount(total, limit = DEFAULT_PAGE_SIZE) {
  const size = Number(limit) > 0 ? Number(limit) : DEFAULT_PAGE_SIZE;
  return Math.max(1, Math.ceil((Number(total) || 0) / size));
}

/** Keep a page inside [1, pageCount]. A hand-edited `?page=` cannot escape it. */
export function clampPage(page, total, limit = DEFAULT_PAGE_SIZE) {
  const n = Math.floor(Number(page));
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.min(n, pageCount(total, limit));
}

/** 1-based page → wire offset. */
export function offsetFor(page, limit = DEFAULT_PAGE_SIZE) {
  const n = Math.floor(Number(page));
  const size = Number(limit) > 0 ? Number(limit) : DEFAULT_PAGE_SIZE;
  return Math.max(0, (Number.isFinite(n) && n > 0 ? n - 1 : 0) * size);
}

/** Wire offset → 1-based page. */
export function pageOf(offset, limit = DEFAULT_PAGE_SIZE) {
  const size = Number(limit) > 0 ? Number(limit) : DEFAULT_PAGE_SIZE;
  const off = Number(offset);
  if (!Number.isFinite(off) || off <= 0) return 1;
  return Math.floor(off / size) + 1;
}
